import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import FuelingSummaryDetailSection from '../sections/FuelingSummaryDetailSection';
import { formatDate } from 'features/shared/helpers/Formatters';

interface RouteProps  {
  year: string;
  month: string;
}

const ChargingSummaryDetailPage = () => {
  // translation
  const tLabels = useTranslation("shared\\moduleNames").t;

  // router
  const routeParams = useParams<RouteProps>();
  const year = Number(routeParams.year);
  const month = Number(routeParams.month);

  // helpers
  const getPageTitle = () => { 
    let translate = tLabels("chargingSummaryDetailPage.title");
    let monhtName = formatDate(new Date(year, month - 1, 1), { month: "long" });

    return `${translate} ${monhtName} ${year}`;
  }

  // render
  return (
    <>
      <Header
        title={getPageTitle()}
        includeBreadcrumbs
        links={[
          { to: "/charging-history", text: tLabels("chargningHistory.title") },
        ]}
      />
      <ModuleContent>
        <FuelingSummaryDetailSection 
          year={year}
          month={month}
          commodityDetail="eMobility"
        />
      </ModuleContent>
    </>
  );
}

export default ChargingSummaryDetailPage;